// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import React from 'react';

import Section1 from '../component/home/Section1';
import Section2 from '../component/home/Section2';
import Section3 from '../component/home/Section3';
import Section4 from '../component/home/Section4';
import Section5 from '../component/home/Section5';
import News from '../component/home/News';
// import Zona from '../component/home/Zona';
import Section6 from '../component/home/Section6';
import Section7 from '../component/home/Section7';
// import Section8 from '../component/home/Section8';
// import Section9 from '../component/home/Section9';
// import Section10 from '../component/home/Section10';
import Section11 from '../component/home/Section11';
// import Section12 from '../component/home/Section12';
// import Section13 from '../component/home/Section13';
// import Section14 from '../component/home/Section14';


const Home = () => {

  return (
    <div className="page-wrapper">
      <Section1 />
      <Section2 />
      <Section3 />
      {/* <Section14 /> */}
      <Section5 />
      <News />
      <Section7 />
      <Section4 />
      {/* <Section12 /> */}

      <Section6 />
      {/* <Section8 />

      <Section9 />
      <Section10 /> */}

      {/* <Zona /> */}
      <Section11 />

      {/* <Section13 /> */}

      
    </div>

  )
}
export default Home;
